var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-icon',{staticClass:"button-spinner__wrapper",attrs:{"icon":_vm.$options.consts.ICON.SPINNER,"original":true,"no-hover":true,"width":24,"height":24}})}
var staticRenderFns = []

export { render, staticRenderFns }